import { Component, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

// read-only popup: which room sits in which premises for one booking. Follows
// the assigned-rooms dialog pattern (rooms grouped under their premises).
// data.pairs comes straight from the check-in list row (roomAllocations).
@Component({
  selector: 'app-rooms-view-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './rooms-view-dialog.component.html',
  styleUrls: ['./rooms-view-dialog.component.scss', '../../../../common-style/ac-dialog.scss'],
})
export class RoomsViewDialogComponent {
  // pairs grouped per premises, in first-seen order
  groups: Array<{ propertyName: string; rooms: string[] }> = [];

  constructor(
    public dialogRef: MatDialogRef<RoomsViewDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      bookingId: number | string;
      familyCode: string | null;
      pairs: Array<{ propertyName: string; roomNumber: string }>;
    }
  ) {
    for (const pair of data.pairs || []) {
      let group = this.groups.find((g) => g.propertyName === pair.propertyName);
      if (!group) {
        group = { propertyName: pair.propertyName, rooms: [] };
        this.groups.push(group);
      }
      group.rooms.push(pair.roomNumber);
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
